import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef, useMemo } from 'react';
import MuiFormControlLabel from '@material-ui/core/FormControlLabel';
import { combineClasses, styled, useThemeProps, } from '../../../foundation';
import { FormControlLabelStyle } from './styles';
import { RcFormControlLabelClasses } from './utils';
var _RcFormControlLabel = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcFormControlLabel' });
    var classesProp = props.classes, rest = __rest(props, ["classes"]);
    var classes = useMemo(function () { return combineClasses(RcFormControlLabelClasses, classesProp); }, [classesProp]);
    return React.createElement(MuiFormControlLabel, __assign({}, rest, { ref: ref, classes: classes }));
});
var RcFormControlLabel = styled(_RcFormControlLabel)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), FormControlLabelStyle);
RcFormControlLabel.defaultProps = {};
RcFormControlLabel.displayName = 'RcFormControlLabel';
export { RcFormControlLabel };
var templateObject_1;
